import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import surveyModel from "@/models/survey-quiz/survey";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { onMounted } from "vue";

export default function useScoreTab(props) {
  const { fetchDetailSurveyModel } = surveyModel();

  const { openErrorModal, openDefaultErrorModal } = useValidationModal();

  const vm = getCurrentInstance().proxy;

  let scoreData = reactive({
    surveyGroupId: null,
    isSetScore: false,
    totalScore: 0,
    score: 0,
    minName: "minValue",
    maxName: "maxValue",
    isEdit: true,

    questionList: [
      // {
      //   name: "Question1",
      //   formatType: 1,
      //   choiceList: [
      //     {
      //       name: "Choice1",
      //       score: 1,
      //     },
      //     {
      //       name: "Choice2",
      //       score: 1,
      //     },
      //   ],
      // },
      // {
      //   name: "Question2",
      //   formatType: 2,
      //   choiceList: [
      //     {
      //       name: "Choice",
      //       score: 1,
      //     },
      //   ],
      // },
      // {
      //   name: "Question3",
      //   formatType: 4,
      //   choiceList: [
      //     {
      //       name: "Choice",
      //       score: 1,
      //     },
      //   ],
      // },
    ],
    result: [
      // {
      //   minValue: 1,
      //   maxValue: 1,
      //   bannerImage: { file: null, url: null },
      //   name: "",
      //   desc: "",
      //   note: "",
      //   termEng: "",
      //   termTh: "",
      //   IsDeleteImage: false,
      // },
    ],
  });

  const onUpdateScore = (score, choice) => {
    choice.score = score;
  };

  let maxValueBefore = null;

  const onUpdateMinScore = (minValue, scoreObj, scoreArr) => {
    let index = scoreArr.indexOf(scoreObj);

    if (index > 0) {
      let prevArrIndex = scoreArr[index - 1];

      if (minValue < prevArrIndex.maxValue) {
        scoreObj.minValue = prevArrIndex.maxValue;
        return;
      } else {
        scoreObj.minValue = minValue;
        return;
      }
    } else if (index == 0) {
      scoreObj.minValue = minValue;
    }
  };

  const onUpdateMaxScore = (maxValue, scoreObj, scoreArr) => {
    scoreObj.maxValue = maxValue;
    maxValueBefore = maxValue;

    let index = scoreArr.indexOf(scoreObj);

    let nextArrIndex = scoreArr[index + 1];

    if (nextArrIndex?.maxValue) {
      nextArrIndex.maxValue = scoreObj.maxValue + 1;
      nextArrIndex.minValue = scoreObj.maxValue + 1;
      if (nextArrIndex.minValue > scoreData.totalScore) {
        nextArrIndex.minValue = scoreData.totalScore;
      }
    }

    if (maxValue == scoreData.totalScore) {
      scoreArr.splice(index + 1, 1);
    }

    if (scoreObj.minValue > maxValue) {
      scoreObj.minValue = maxValue;
    }

    vm.$emit("onSetMaxScore", maxValueBefore);
  };

  const onUploadBanner = (image, scoreObj) => {
    scoreObj.bannerImage.file = image.file;
    scoreObj.bannerImage.url = image.url;

    if (!scoreObj.bannerImage.file && !scoreObj.bannerImage.url) {
      scoreObj.IsDeleteImage = true;
    } else {
      scoreObj.IsDeleteImage = false;
    }
  };

  const addResult = () => {
    if (maxValueBefore == scoreData.totalScore) return;

    scoreData.result.push({
      minValue: maxValueBefore + 1 || 0,
      maxValue: maxValueBefore + 1 || 0,
      bannerImage: { file: null, url: null },
      name: "",
      desc: "",
      note: "",
      termEng: "",
      termTh: "",
    });

    vm.$emit("EditSetResult");
  };

  const fetchDetailSurvey = () => {
    return new Promise((resolve) => {
      window.$loading(true);
      fetchDetailSurveyModel.payload.Survey_GroupId = scoreData.surveyGroupId;

      store
        .dispatch("api/apiRequest", fetchDetailSurveyModel)
        .then((response) => {
          resolve(response);
          vm.$emit("onSetScoreData", scoreData);
          const responseInformation = response.data.resp.infomation;
          const responseSection = response.data.resp.section;
          const responseResult = response.data.resp.result;

          scoreData.isSetScore = responseInformation.isresult;
          scoreData.isEdit = responseInformation.isedit;

          scoreData.result = [];
          responseResult.map((result) => {
            scoreData.result.push({
              resultId: result.resultid,
              minValue: result.scores_min,
              maxValue: result.scores_max,
              bannerImage: { url: result.cover_image_url },
              name: result.title,
              desc: result.description,
              note: result.note,
              termEng: result.detail_htmleditor_en,
              termTh: result.detail_htmleditor_th,
            });

            maxValueBefore = result.scores_max;
          });

          scoreData.questionList = [];
          responseSection.map((section) => {
            section.question.map((question) => {
              scoreData.questionList.push({
                name: question.ques_name_htmleditor.replace(/<[^>]*>/g, ""),
                formatType: question.choice_mode,
                type: question.input_type,
                questionId: question.questionid,
                choiceList: [],
              });

              let formChoiceList = [];
              scoreData.questionList.map((question) => {
                formChoiceList = question.choiceList;
              });

              if (question.option) {
                question.option.map((choice) => {
                  formChoiceList.push({
                    name: choice.option,
                    other: choice.isotheranswer,
                    image: choice.option_image_url,
                    questionId: question.questionid,
                    choiceId: choice.optionid,
                    score: choice.scores,
                  });
                });
              }
            });
          });
        })
        .catch((err) => {
          openDefaultErrorModal(err);
        })
        .finally(() => {
          window.$loading(false);
        });
    });
  };

  const onRemoveSetResult = (setResult, index) => {
    setResult.splice(index, 1);

    if (scoreData.result.length > 0) {
      scoreData.result[0].minValue = 1;
    }

    if (scoreData.result[index])
      scoreData.result[index].minValue = setResult[index - 1]?.maxValue
        ? setResult[index - 1]?.maxValue + 1
        : 1;

    vm.$emit("EditSetResult");
  };

  const onSetMaxScore = (maxScore) => {
    vm.$emit("onSetMaxScore", maxScore);
  };

  watch(
    scoreData,
    () => {
      vm.$emit("onSetScoreData", scoreData);
    },
    { deep: true }
  );

  watch(
    scoreData,
    () => {
      scoreData.totalScore = scoreData.questionList.reduce((acc, question) => {
        const questionScore = question.choiceList.reduce(
          (choiceAcc, choice) => {
            return choiceAcc + choice.score;
          },
          0
        );

        return acc + questionScore;
      }, 0);
    },
    { deep: true }
  );

  watch(
    scoreData,
    () => {
      vm.$emit("onSetScoreData", scoreData);
    },
    { deep: true }
  );

  watch(
    () => props,
    () => {
      if (props?.isEdit) fetchDetailSurvey();
    },
    { deep: true }
  );

  onBeforeMount(() => {
    if (router.currentRoute.query.surveyGroupId) {
      scoreData.surveyGroupId = parseInt(
        router.currentRoute.query.surveyGroupId
      );
    } else {
      scoreData.surveyGroupId = parseInt(router.currentRoute.params.ref);
    }

    if (scoreData.surveyGroupId) {
      fetchDetailSurvey().then(() => {
        if (scoreData.result.length == 0) {
          scoreData.result.push({
            minValue: maxValueBefore || 1,
            maxValue: maxValueBefore || 1,
            bannerImage: { file: null, url: null },
            name: "",
            desc: "",
            note: "",
            termEng: "",
            termTh: "",
          });
        }
      });
    }
    vm.$emit("onSetScoreData", scoreData);
    scoreData.totalScore = scoreData.questionList.reduce((acc, question) => {
      //คำนวณผลรวมของคะแนนทั้งหมด
      const questionScore = question.choiceList.reduce((choiceAcc, choice) => {
        return choiceAcc + choice.score;
      }, 0);

      return acc + questionScore;
    }, 0);
  });

  return {
    scoreData,
    onUpdateScore,
    onUpdateMinScore,
    onUpdateMaxScore,
    onUploadBanner,
    addResult,
    maxValueBefore,
    onRemoveSetResult,
    onSetMaxScore,
  };
}
